import axios from "axios"
import library from "../../../utils/Library"

export const addEntityGroupGlobalNotificationEAuthz = async (data) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("global_notification") + "/addEntityGroupGlobalNotificationEAuthz"
  return await axios({
    url: URL,
    method: "POST",
    data,
    headers: { Authorization: `Bearer ${TOKEN}` },
  })
}
